import { useImperativeHandle, ReactElement, MutableRefObject, useState } from 'react';
import { App, Button, Flex, Form, FormInstance, FormItemProps, FormProps, ModalProps, Spin, Tag } from 'antd';
import { useTranslation } from 'react-i18next';
import dayjs from "dayjs";
import { dateFormat } from "@/utils/format";
import { FormWrap } from './style'
import { User, UserPermissionEnum } from '@/types/user';
import { useSelector } from 'react-redux';
import { RootState } from '@/store';
import { hasPermission } from '@/utils/user';

type ModelFormRef<FormDetail> = FormInstance<FormDetail> | null;

interface SFormProps<FormDetail> extends ModalProps {
	handleCancel: () => void;
	handleOk: (data: FormDetail) => Promise<any>;
	handleDel?: (data: FormDetail) => Promise<void>;
	data: FormDetail | null; // 详情
	formItems?: Array<FormItemProps<FormDetail>>;
	modelFormRef: MutableRefObject<ModelFormRef<FormDetail>>;
	delContentTip?: string;
	formProps?: FormProps;
	loading?: boolean;
	order?: any;
	setRequirementDetail?: (d: any) => void;
	isSupplier?: boolean | undefined;
	btnList?: any
}

const SForm = <FormDetail,>({
	modelFormRef,
	formProps,
	loading,
	order,
	isSupplier,
	btnList,
	...props
}: SFormProps<FormDetail>): ReactElement => {
	const {
		handleCancel,
		handleOk,
		data,
		formItems,
		setRequirementDetail
	} = props;
	const { t } = useTranslation();
	const { notification } = App.useApp();
	const [modalForm] = Form.useForm<FormDetail>();

	const [okLoading, setOkLoading] = useState<boolean>(false)
	const [cancelDisabled, setCancelDisabled] = useState<boolean>(false)
	useImperativeHandle(modelFormRef, () => modalForm);

	const currentUser: User = useSelector((state: RootState) => state.userReducer.curUser);


	const onOk = () => {
		setOkLoading(true)
		setCancelDisabled(true)
		modalForm
			.validateFields()
			.then((res) => {
				handleOk(res).then((flag) => {
					if (!!!flag) { 	//	传递flag手动结束promise，不清表单
						modalForm.resetFields();
					}
					setOkLoading(false)
					setCancelDisabled(false)
				});
			})
			.catch((err) => {
				const errTitle = t('common.addError');
				const errorDesc = err?.errorFields[0]?.errors[0] ?? '';
				notification.error({
					placement: 'top',
					message: errTitle,
					description: errorDesc,
				});
				setOkLoading(false)
				setCancelDisabled(false)
			})
	};

	const onClear = () => {
		modalForm.resetFields();
		handleCancel();
	};

	return (
		<>
			{loading ? <Flex style={{ width: '100%', height: '100%' }} justify='center' align='center'><Spin /></Flex> :
				<div style={{ width: '100%', height: '100%', overflow: 'auto' }}>
					<div style={{ marginBottom: 20 }}>
						<span>{t("purchase.state")}: {order?.order?.acceptState === null ? <Tag color="blue">{t("purchase.pend")}</Tag> : order?.order?.acceptState === 1 ? <Tag color="green">{t("purchase.acceptType")}</Tag> : <Tag color="red">{t("purchase.rejectType")}</Tag>}</span>
						{(order?.order?.acceptState === 0 && hasPermission(currentUser, [UserPermissionEnum.PUR_ORDER_EDIT]) && !isSupplier) && <Button type={'primary'} onClick={() => {
							setRequirementDetail && setRequirementDetail({ ...order?.quotationRequest?.requirementItem, product: order?.product })
							onClear()
						}}>
							{t("purchase.reOrder")}
						</Button>
						}
					</div>
					{order?.order?.acceptState === 0 &&
						<div>
							<p>{t("purchase.rejectDate")}: {dateFormat(dayjs(order?.order?.acceptedAt))}</p>
							<p>{t("purchase.operationPerson")}: {order?.order?.acceptor.name1 || order?.order?.acceptor.name2 || order?.order?.acceptor.mobile}</p>
						</div>
					}
					<FormWrap>
						<Form<FormDetail>
							form={modalForm}
							layout="horizontal"
							labelWrap
							style={{ width: '100%', height: '100%', paddingBottom: 60, overflow: 'none' }}
							autoComplete="off"
							initialValues={data ?? {}}
							{...formProps}
						>
							{formItems?.map((item, index) => <Form.Item key={index} {...item} />)}
						</Form>
					</FormWrap>
				</div>
			}
			{
				isSupplier ?
					null :
					(
						<div style={{ position: 'absolute', bottom: 10, right: 10, width: '100%', background: '#fff', height: 40, paddingTop: 16 }}>
							<Flex gap={10} justify='flex-end'>
								<Button disabled={cancelDisabled} onClick={onClear} type='link'>{t('common.cancel')}</Button>
								<Button loading={okLoading} onClick={onOk} type='primary'>{t('common.confirm')}</Button>
							</Flex>
						</div >
					)
			}
			{isSupplier && btnList && btnList()}
		</>
	);
};

export default SForm;
